import React from 'react';
import { connect } from 'react-redux';
import Col from 'react-bootstrap/Col';
import properties from '../../../modules/ajio-util/properties';
import { hideModal } from '../../../actions/modal';

class PriceSavingInfoPopup extends React.Component {
  constructor(props) {
    super(props);
    this.textContent = {
      discount: 'Discount',
      couponDiscount: 'Coupon savings *',
      promoDiscount: 'Promo Discount *',
      totalSaving: 'Total savings',
      discountMsg: '* Total coupon savings on this product is ',
      coupounNotApplicable: '*Coupon not applicable'
    };
    this.previousActiveElement = null;
  }

  componentDidMount() {
    this.previousActiveElement = document.activeElement;
  }
  componentWillUnmount() {
    if (this.previousActiveElement) {
      this.previousActiveElement.focus();
    }
  }
  render() {
    const { product = {} } = this.props;

    return this._showSavingPopup();
  }

  _showSavingPopup() {
    const { product = {} } = this.props;

    const { priceInfo = {}, voucherMessages = '' } = product;

    const {
      discount = '',
      discountPercentage = '',
      originalPrice,
      netPrice,
      totalSaving = '',
      couponSaving = '',
      promoSaving = ''
    } = priceInfo;

    return (
      <div className="saving-popup">
        <p role='heading' aria-level={2}>Savings</p>
        <section>
          {discount.value > 0 && (
            <div className="discount-section">
              {this.textContent.discount}({parseInt(discountPercentage)}
              %)
              <span> {discount.formattedValue}</span>
            </div>
          )}
          {couponSaving.value > 0 ? (
            <div className="coupon-discount-section">
              {this.textContent.couponDiscount}
              <span>{couponSaving.formattedValue}</span>
            </div>
          ) : null}
          {promoSaving.value > 0 ? (
            <div className="promo-discount-section">
              {this.textContent.promoDiscount}
              <span>{promoSaving.formattedValue}</span>
            </div>
          ) : null}
          <div className="total-saving">
            {this.textContent.totalSaving}
            <span>{totalSaving.formattedValue}</span>
          </div>
        </section>
        {voucherMessages == 'Applied' && (
          <div className="discount-info">
            {this.textContent.discountMsg}
            <span> {couponSaving.formattedValue} </span>
          </div>
        )}
        {voucherMessages == 'Not Applicable' ? (
          <div className="discount-info">{this.textContent.coupounNotApplicable}</div>
        ) : null}
        <div
          id="saving-popup-btn"
          onClick={() => {
            this.props.hideModal('product-saving');
          }}
          role="button"
          tabIndex={0}
        >
          {' '}
          Done{' '}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideModal: name => {
      dispatch(hideModal(name));
    }
  };
};

export default connect(null, mapDispatchToProps)(PriceSavingInfoPopup);
